import axios from 'axios'

export default {
    getPublisher(){
        return {"google":"Google",
                             "waze":"Waze",
                             "facebook":"Facebook",
                             "tomtom":"TomTom",
                             "bing":"Bing",
                             "cylex":"Cylex",
                             "yellowpages":"Yellow pages",
                             "foursquare":"Foursquare",
                             "here":"Here" 
                            };
    },
    async createJob(locationName,AddressLine1,City) {
        let postData =[{
            "locationName":locationName,
            "locationAddress":AddressLine1 + " ," + City
        }];
      let res = await axios.post(process.env.VUE_APP_SERVER + "run",postData);

      //console.log(res.data)
      return res.data;
    },
    async getJobInfo(JobNumber){
        let res = await axios.get(process.env.VUE_APP_SERVER + `job?id=${JobNumber}`) 
        return res.data;
    },
    async getResult(JobNumber){
        let res = await axios.get(process.env.VUE_APP_SERVER + `result?id=${JobNumber}`) 
        let Publisher = this.getPublisher()
        return res.data.filter(x=>Publisher[x.Platform.toLowerCase()]);
    },
}